import React, { useState } from "react";
import classNames from "../classNames";

function TabbedCard({
  tabs = [],
  panels = {},
  defaultTab,
  onChangeTab,
  className,
  cardStyle,
}) {
  const firstId = tabs.length > 0 ? tabs[0].id : null;
  const [activeTab, setActiveTab] = useState(defaultTab ?? firstId);

  const handleTabClick = (id) => {
    setActiveTab(id);
    onChangeTab?.(id);
  };

  const content = panels[activeTab] ?? null;

  if (tabs.length === 0) return null;

  return (
    <div
      className={classNames(
        "d-flex flex-column bg-white rounded-3 shadow-sm",
        className,
      )}
      style={{
        overflow: "hidden",
        flex: 1,
        minHeight: 0,
        ...cardStyle,
      }}
    >
      <div className="flex-shrink-0 px-2 pt-0 pb-0 border-bottom border-light-subtle">
        <ul className="nav nav-tabs card-header-tabs gap-1" role="tablist">
          {tabs.map((tab) => (
            <li className="nav-item" key={tab.id}>
              <button
                type="button"
                role="tab"
                onClick={() => handleTabClick(tab.id)}
                className={classNames(
                  "nav-link d-flex align-items-center gap-2 border",
                  activeTab === tab.id
                    ? "bg-white"
                    : "bg-light border-secondary",
                )}
                style={{
                  borderTopLeftRadius: "6px",
                  borderTopRightRadius: "6px",
                  borderBottomWidth: "2px",
                  fontWeight: activeTab === tab.id ? 600 : 500,
                  paddingTop: "0.5rem",
                  paddingBottom: "0.5rem",
                  ...(activeTab === tab.id && {
                    borderLeftColor: "#dee2e6",
                    borderRightColor: "#dee2e6",
                    borderTopColor: "#dee2e6",
                    borderBottomColor: "#dee2e6",
                  }),
                }}
              >
                {tab.icon && <i className={tab.icon} />}
                {tab.label}
              </button>
            </li>
          ))}
        </ul>
      </div>
      <div
        className="card-body p-0 flex-grow-1 bg-transparent border-0"
        style={{ minHeight: 0, overflow: "auto" }}
      >
        {content}
      </div>
    </div>
  );
}

export default TabbedCard;
